"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sxor = exports.randomize = exports.numberUpTo = void 0;
/**
 * @function Metoda losująca liczbę z zakresu [0, from)
 * @description
 *
 * @param {Number} from
 *
 * @returns {Number}
 */
var numberUpTo = function (from) { return Math.floor(Math.random() * from); };
exports.numberUpTo = numberUpTo;
/**
 * @description Metoda generująca losowy łańcuch znaków o danej długości
 * @function
 *
 * @param {Number} len Długość generowanego łańcucha
 * @param {Boolean} base Generować w base10 czy base16
 * @param {Boolean} [firstLetter] Czy łańcuch ma zaczynac się od litery
 *
 * @returns {String}
 */
var randomize = function (len, inBase, firstLetter) {
    if (len === void 0) { len = 10; }
    var base = (inBase === true) ? 16 : (inBase || 10);
    var output = '';
    if (firstLetter) {
        output = String.fromCharCode((0, exports.numberUpTo)(26) + 97);
    }
    while (output.length < len) {
        output += Math.random().toString(base).substr(2);
        output = output.substr(0, len);
    }
    return output;
};
exports.randomize = randomize;
/**
 * @description Metoda przechodząca znak po znaku i wykonująca operację bitową xor
 * na znakach klucza i kodowanego stringa. Stringi nie muszą być tej samej wielkości.
 * @function
 *
 * @param {String} source
 * @param {String} key
 *
 * @returns {String}
 */
var sxor = function (source, key) {
    var keyLen = key.length;
    var sourceLen = source.length;
    var output = '';
    for (var i = 0; i < sourceLen; i += 1) {
        // mieszamy znaki bitowym XOR na charCodach
        var sourceCode = source.charCodeAt(i);
        var keyCode = key.charCodeAt(i % keyLen);
        // eslint-disable-next-line no-bitwise
        output += String.fromCharCode(sourceCode ^ keyCode);
    }
    return output;
};
exports.sxor = sxor;
